module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "contents"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('strong', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/preface#preface"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REFACE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01"
    }
  }, [_c('strong', [_vm._v("1."), _c('br'), _vm._v("From Homer to Shakespeare:"), _c('br'), _vm._v("The Rise of Service Translation"), _c('br'), _vm._v("in the Late Eighteenth Century")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("2."), _c('br'), _vm._v("The Translation as a Doppelgänger:"), _c('br'), _c('em', [_vm._v("Amphitryon")]), _vm._v(" by Molière and Kleist")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("3."), _c('br'), _vm._v("Hölderlin as Translator:"), _c('br'), _vm._v("The Perils of Interpretation")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("4."), _c('br'), _vm._v("The Paradox of the Translator:"), _c('br'), _vm._v("Goethe and Diderot")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/coda#coda",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Coda:"), _c('br'), _vm._v("From the Nineteenth to the Twenty-First Century")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/abbreviations#abbreviations",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("BBREVIATIONS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OTES")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/bibliography#bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IBLIOGRAPHY")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/index#index",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NDEX")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef6128c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 69
// module chunks = 0